"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityInfoRequest = void 0;
var ActivityInfoRequest = /** @class */ (function () {
    function ActivityInfoRequest() {
    }
    return ActivityInfoRequest;
}());
exports.ActivityInfoRequest = ActivityInfoRequest;
//# sourceMappingURL=activityInfo.request.js.map